import React from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core'

const style = theme => ({
  root: {
    textAlign: 'right'
  },
  name: {
    fontWeight: 'bold'
  },
  address: {
    fontWeight: 100,
    lineHeight: '1em',
    fontSize: '0.85em'
  }
})

export const GarageInfoBase = ({ name, address, classes }) => (
  <div className={classes.root}>
    <Typography className={classes.name} color="inherit">
      {name}
    </Typography>
    <Typography className={classes.address} color="inherit" variant="body2">
      {address}
    </Typography>
  </div>
)

export const GarageInfo = withStyles(style)(GarageInfoBase)
